import React from 'react';

import styled from 'styled-components';
import { connect } from 'react-redux';
import QuizOption from '../../Quiz/components/QuizOption';

const Title = styled.h3`
  margin-bottom: 15px;
`;

const Body = styled.p`
  margin-bottom: 25px;
  margin-top: 20px;
  font-size: 15px;
  font-style: italic;
`;

const Question = styled.p`
  margin-bottom: 15px;
`;

const ResultItem = ({
  data,
  showCorrectAnswers,
  quizState,
  quizData
}) => {
  const {
    title,
    options,
    wrongAnswerFeedback,
    correctAnswerFeedback,
    question,
    correctOption,
    passed
  } = data;
  if (!showCorrectAnswers && passed) return null;
  return (
    <div>
      <hr />
      <Title>{title}</Title>
      <Question dangerouslySetInnerHTML={{ __html: question }} />
      {
        options.map(({
          correct,
          label,
          selected,
          nuetral,
          id
        }) => (
          <QuizOption
            key={id}
            correct={correct}
            selected={selected}
            nuetral={nuetral}
            // eslint-disable-next-line no-nested-ternary
            state={id === correctOption ? 'correct' : (selected) ? 'wrong' : ''}
            isResult
          >
            {label}
          </QuizOption>
        ))
      }
      <Body
        dangerouslySetInnerHTML={{
          __html: passed ? correctAnswerFeedback : wrongAnswerFeedback
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  quizData: state.quiz.quizData,
  quizState: state.quiz.quizState,
});

export default connect(mapStateToProps, null)(ResultItem);
